import type { DrinkEvent, Group, Participant } from '@lbc/shared';

import { createAchievements } from './achievements';

interface AchievementsListProps {
  group: Pick<Group, 'timezone' | 'dayBoundaryHour'>;
  participants: Participant[];
  participant: Participant;
  events: DrinkEvent[];
}

export function AchievementsList({
  group,
  participants,
  participant,
  events,
}: AchievementsListProps) {
  const achievements = createAchievements({ group, participants, participant, events });
  const unlockedCount = achievements.filter((achievement) => achievement.unlocked).length;

  return (
    <section className="achievements" aria-labelledby="achievements-title">
      <div className="section-heading">
        <div>
          <p className="step-label">Kleine Meilensteine</p>
          <h2 id="achievements-title">Achievements</h2>
        </div>
        <span className="people-count">
          {unlockedCount}/{achievements.length} geschafft
        </span>
      </div>
      <p className="achievements__schedule">Wird täglich um 06:00 Uhr ausgewertet.</p>
      <ul className="achievements-list">
        {achievements.map((achievement) => {
          const progressTotal = achievement.progressTotal;
          const progressValue = achievement.progressValue;
          return (
            <li
              className={`achievement ${achievement.unlocked ? 'achievement--unlocked' : 'achievement--locked'}`}
              key={achievement.id}
            >
              <span className="achievement__status" aria-hidden="true">
                {achievement.unlocked ? '✓' : '·'}
              </span>
              <div>
                <h3>{achievement.title}</h3>
                <p>{achievement.description}</p>
                <small>{achievement.unlocked ? achievement.detail : achievement.progress}</small>
                {progressTotal !== undefined && progressValue !== undefined ? (
                  <div
                    className="achievement__progress"
                    role="progressbar"
                    aria-label={`${achievement.title}: ${progressValue} von ${progressTotal} Tagen`}
                    aria-valuemin={0}
                    aria-valuemax={progressTotal}
                    aria-valuenow={progressValue}
                  >
                    {Array.from({ length: progressTotal }, (_, index) => (
                      <span
                        className={
                          index < progressValue
                            ? 'achievement__progress-segment achievement__progress-segment--filled'
                            : 'achievement__progress-segment'
                        }
                        key={index}
                        aria-hidden="true"
                      />
                    ))}
                  </div>
                ) : null}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
